__turbopack_context__.v({
  "button-submit": "Ab-lEG_button-submit",
  "centerForm": "Ab-lEG_centerForm",
});
